import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {Icon, DossierStateResume as CoreDossierStateResume} from 'front-onceforall-core';

import {handleDownloadDossierOverview, handleFocusDocument} from '../utils';

function DossierStateResume(props) {
  const [
    organisation,
    currentLocale
  ] = useSelector(state => [state.organisation, state.i18n.locale]);

  function onDownloadDossierOverview() {
    handleDownloadDossierOverview(organisation.organisationId, currentLocale, props.dossierCountry);
  }

  return (
    <div className="mt-5 mb-5">
      {props.loading &&
        <div className="col-12 flex-container justify-content-center">
          <Icon
            icon="loader"
            size={40}
          />
        </div>
      }
      {props.dossierState &&
      <CoreDossierStateResume
        dossierState={props.dossierState}
        onDownloadDossierOverview={onDownloadDossierOverview}
        onClickDocument={handleFocusDocument}
      />
      }
    </div>

  );
}

DossierStateResume.propTypes = {
  loading: PropTypes.bool.isRequired,
  dossierCountry: PropTypes.string.isRequired,
  dossierState: PropTypes.shape({
    dossierState: PropTypes.string.isRequired,
    invalidDocuments: PropTypes.array,
    almostExpiredDocuments: PropTypes.array
  })
};

export default DossierStateResume;
